import React from 'react';
import { jwtDecode } from "jwt-decode";  // Correcte import zonder extra haakjes

function GetUserInfo() {
  const token = sessionStorage.getItem('jwt');  // Haal de token op
  // Controleer of een token aanwezig is en decodeer het, anders retourneer een leeg object
  const jwt = token ? jwtDecode(token) : {};

  return jwt;
}

export default GetUserInfo;
